import React from 'react';

interface DashboardTabsProps {
    activeTab: 'basic' | 'analytics';
    onChange: (tab: 'basic' | 'analytics') => void;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({ activeTab, onChange }) => {
    const tabStyle: React.CSSProperties = {
        background: '#F4F4F5',
        borderRadius: 8,
        padding: 4,
        display: 'flex',
        gap: 4,
        width: 'fit-content',
        marginBottom: 24,
    };

    const getButtonStyle = (isActive: boolean): React.CSSProperties => ({
        background: isActive ? '#18181B' : 'transparent',
        color: isActive ? '#FFFFFF' : '#71717A',
        borderRadius: 6,
        padding: '8px 16px',
        border: 'none',
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        transition: 'all 0.2s',
    });

    return (
        <div style={tabStyle}>
            <button
                style={getButtonStyle(activeTab === 'basic')}
                onClick={() => onChange('basic')}
            >
                基础统计
            </button>
            <button
                style={getButtonStyle(activeTab === 'analytics')}
                onClick={() => onChange('analytics')}
            >
                运营分析
            </button>
        </div>
    );
};

export default DashboardTabs;
